// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pp-interaction-feedback .v-input,.pp-interaction-feedback .v-label{font-size:inherit}", ""]);
// Exports
module.exports = exports;
